import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../services'
import { UtilityDetailsInitialState } from '../utilityDetails.slice'
import { IUtility } from '../../../types/UtilityDetails'

export const fetchUtilityDetailsAsync = createAsyncThunk(
  'details/fetchUtilityDetails',
  async (pwsid: string, { rejectWithValue }) => {
    try {
      const res = await EpaApi.fetchUtilityDetail(pwsid)
      return (res as AxiosResponse<any, any>).data
    } catch (error) {
      console.error(error)
      return rejectWithValue({
        message: 'An unknown error occurred',
      })
    }
  },
)

export const fetchUtilityDetailsAsyncBuilder = (
  builder: ActionReducerMapBuilder<UtilityDetailsInitialState>,
) => {
  builder.addCase(fetchUtilityDetailsAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(
    fetchUtilityDetailsAsync.fulfilled,
    (state, action: PayloadAction<IUtility>) => {
      state.loading = false
      state.success = true
      state.data = action.payload
    },
  )
  builder.addCase(fetchUtilityDetailsAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = false
    state.error = action.payload
  })
}
